import { useMemo, useRef } from "react";
import { Box, Checkbox } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from "moment";
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";
import { formatCurrency } from "../../../utils/mathUtils";
import { PopoverModal } from "../../../components/popoverModal/PopoverModal";
import { CheckboxSeleccion } from "../../../components/checkboxSeleccion/CheckboxSeleccion";

export const useGetColumns = ({
    allowedWrite,
    handleView,
    idProfesionalLiquidacion,
    seleccionados,   // Set of idProfesionalLiquidacion
    toggleSeleccion,
    seleccionarTodos,
    liquidaciones,      // Array de liquidaciones
    mostrarOrdenCompra
}) => {
    return useMemo(() => {
        const baseColumns = [
            {
                headerName: '',
                field: 'action',
                cellClassName: 'grid-actions-column',
                minWidth: 35,
                maxWidth: 35,
                width: 35,
                sortable: false,
                renderCell: ({ row }) => (
                    <PopoverModal>
                        <div className='popover-modal-content'>
                            <div
                                aria-hidden='true'
                                onClick={() => handleView(row)}
                                className='item-option clickable-option'
                            >
                                <VisibilityIcon className='edit-icon' />
                                <span className='toggle-action'>Ver detalle de liquidación</span>
                            </div>
                        </div>
                    </PopoverModal>
                )
            },
            ...(mostrarOrdenCompra ? [{ field: 'numeroOC', headerName: 'OC', width: 120 }] : []),
            { field: 'cuenta', headerName: 'Cuenta', width: 90 },
            { field: 'centroCosto', headerName: 'Costo', width: 60 },
            { field: 'centroAlmacenamiento', headerName: 'Centro', width: 65 },
            { field: 'idEvaluacion', headerName: 'Contrato', width: 75 },
            { field: 'paciente', headerName: 'Paciente', width: 160 },
            {
                field: 'periodoContrato',
                headerName: 'Periodo contrato',
                width: 140,
                valueGetter: (_, row) =>
                    `${moment(row.fechaDesdeEvaluacion).format('DD/MM/YYYY')} - ${moment(row.fechaHastaEvaluacion).format('DD/MM/YYYY')}`
            },
            { field: 'fechaDesdeProfesional', headerName: 'F. desde', width: 80, type: 'date' },
            { field: 'fechaHastaProfesional', headerName: 'F. Hasta', width: 80, type: 'date' },
            { field: 'diasServicio', headerName: 'Días', width: 50 },
            { field: 'diasSuspendido', headerName: 'Días susp.', description: 'Días de suspensión', width: 70 },
            { field: 'totalDias', headerName: 'T. Días', description: 'Total días', width: 70 },
            { field: 'programa', headerName: 'Programa', width: 70 },
            { field: 'planCuidado', headerName: 'Plan', width: 170 },
            { field: 'figuraProfesional', headerName: 'Figura', width: 90 },
            {
                field: 'montoAjuste',
                headerName: 'Ajuste',
                width: 60,
                align: 'center',
                headerAlign: 'center',
                renderCell: ({ row }) => {
                    const tieneAjuste = row.montoAjuste != null && row.montoAjuste !== 0;
                    if (!tieneAjuste) return null;
                    return (
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            height: '100%'
                        }}>
                            <Box sx={{ width: 12, height: 12, background: '#52BA50', borderRadius: '50%' }} />
                        </Box>
                    );
                }
            },
            {
                field: 'tieneConexion',
                headerName: 'Cnx',
                width: 50,
                valueGetter: (value) => value ? 'SI' : 'NO'
            },
            {
                field: 'liquidacionTotal',
                headerName: 'Total',
                width: 90,
                valueGetter: (value) => formatCurrency(value || 0)
            },
        ];

        if (allowedWrite) {
            baseColumns.unshift({
                field: 'seleccion',
                headerName: '',
                minWidth: 38,
                maxWidth: 38,
                width: 38,
                sortable: false,
                noPaddingHeader: true,
                noPadding: true,
                align: 'center',
                headerAlign: 'center',
                renderHeader: () => (
                    <Checkbox
                        size="small"
                        onChange={() => seleccionarTodos(idProfesionalLiquidacion)}
                        checked={seleccionados.has(idProfesionalLiquidacion)}
                    />
                )
            });
        }

        return generateColumnsDefaultConfiguration(baseColumns, true);
    }, [allowedWrite, handleView, idProfesionalLiquidacion, seleccionados, seleccionarTodos, liquidaciones, mostrarOrdenCompra]);
};
